import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "eye-closed",
  "use": "eye-closed-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol fill=\"currentColor\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"eye-closed\"><path d=\"M1 5s.697 1.095 2 2.14M15 5s-.697 1.095-2 2.14m-3 1.582a7.327 7.327 0 01-4.12-.035m4.12.035c1.207-.34 2.214-.952 3-1.582m-3 1.582L11 11M5.88 8.687C4.726 8.341 3.76 7.75 3 7.14m2.88 1.547L5 11m8-3.86L15 9M3 7.14L1 9\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol